export default function MentorSection() {
  return (
    <section className="py-14 sm:py-28 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div className="md:col-span-2 flex justify-center">
            <div className="relative w-full max-w-[260px] sm:max-w-[320px] md:max-w-none">
              <div className="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-14 h-14 sm:w-24 sm:h-24 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl sm:rounded-3xl opacity-20"></div>
              <img
                alt="Esaúl Lorenzo - Mentor de productos digitales con inteligencia artificial"
                title="Esaúl Lorenzo mentor digital"
                className="relative rounded-2xl sm:rounded-3xl shadow-2xl w-full h-auto"
                src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/6db1f902baa70cf225dc0ef59a98b73c.png"
              />
              <div className="absolute -bottom-4 -right-2 sm:-bottom-6 sm:-right-6 flex gap-3">
                <div className="bg-white rounded-xl sm:rounded-2xl px-3 sm:px-4 py-2 shadow-lg">
                  <div className="text-lg sm:text-2xl font-bold text-gray-900">$100K+</div>
                  <div className="text-[10px] sm:text-xs text-gray-600">Facturados</div>
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3 text-center md:text-left mt-4 md:mt-0">
            <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-xs sm:text-sm font-semibold uppercase mb-3 sm:mb-4">
              TU MENTOR
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-4 sm:mb-6 tracking-tight">
              ESAÚL LORENZO
            </h2>

            <div className="border-l-4 border-yellow-500 pl-4 sm:pl-6 space-y-3 sm:space-y-5 text-left">
              <p className="text-sm sm:text-lg text-gray-700 leading-relaxed">
                Llevo <strong className="text-yellow-600">7 años</strong> construyendo negocios digitales y ayudando a cientos de emprendedores a que por fin logren vivir de internet.
              </p>
              <p className="text-sm sm:text-lg text-gray-700 leading-relaxed">
                No te hablo desde la teoría, te hablo desde los resultados: El año pasado, mis sistemas generaron más de <strong className="text-yellow-600">$100,000 USD</strong> facturados con pauta digital. Lo que vas a aprender es exactamente lo que <strong className="text-yellow-600">HAGO</strong> cada mañana para mover la aguja de mi negocio.
              </p>
              <p className="text-sm sm:text-lg text-gray-700 leading-relaxed">
                Mi misión es que tú también te lleves tu tajada de este mercado millonario. Deja de adivinar y <strong className="text-yellow-600">copia mi sistema</strong> para ahorrarte años de errores y miles de dólares perdidos.
              </p>
            </div>

            <div className="flex flex-wrap justify-center md:justify-start gap-2 sm:gap-3 mt-6 sm:mt-8">
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl sm:rounded-2xl px-3 sm:px-4 py-2 sm:py-3 shadow-sm">
                <i className="ri-time-line text-base sm:text-xl text-emerald-600 flex-shrink-0"></i>
                <span className="text-xs sm:text-sm font-semibold text-gray-800 whitespace-nowrap">
                  7+ Años de Experiencia
                </span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl sm:rounded-2xl px-3 sm:px-4 py-2 sm:py-3 shadow-sm">
                <i className="ri-money-dollar-circle-line text-base sm:text-xl text-green-600 flex-shrink-0"></i>
                <span className="text-xs sm:text-sm font-semibold text-gray-800 whitespace-nowrap">
                  $100K+ Facturados
                </span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl sm:rounded-2xl px-3 sm:px-4 py-2 sm:py-3 shadow-sm">
                <i className="ri-group-line text-base sm:text-xl text-teal-600 flex-shrink-0"></i>
                <span className="text-xs sm:text-sm font-semibold text-gray-800 whitespace-nowrap">
                  Cientos de Alumnos
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
